// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  version: "0.0.1",
  firebaseConfig: {
    apiKey: "AIzaSyC4K17dzS0ETKynAjVuAWRks7HnyQIqQLQ",
    authDomain: "rengo-rienzi-valencia-gonzalez.firebaseapp.com",
    databaseURL: "https://rengo-rienzi-valencia-gonzalez.firebaseio.com",
    projectId: "rengo-rienzi-valencia-gonzalez",
    storageBucket: "rengo-rienzi-valencia-gonzalez.appspot.com",
    messagingSenderId: "513462314498",
    appId: "1:513462314498:web:73fdf72a7f5bce2f99a91b",
    measurementId: "G-WP4YW18XYZ"
  }
};
